// ViaCEP — API pública oficial (sem chave, sem custo), pedido por Jason
// 2026-09-19 ("usar aquela busca do Google que já tem no site (api) ou
// deve estar usando viacep"). Escolhido ViaCEP: é especializado em CEP
// brasileiro (dado direto dos Correios), enquanto a API do Google é de
// geocoding genérico — pediria chave/faturamento pra um caso de uso mais
// simples do que ela resolve.
export async function buscarEnderecoPorCep(cep) {
  const limpo = String(cep || '').replace(/\D/g, '');
  if (limpo.length !== 8) return null;

  try {
    const resposta = await fetch(`https://viacep.com.br/ws/${limpo}/json/`);
    if (!resposta.ok) return null;
    const dados = await resposta.json();
    if (dados.erro) return null;
    return {
      endereco: dados.logradouro || '',
      bairro: dados.bairro || '',
      cidade: dados.localidade || '',
      estado: dados.uf || '',
    };
  } catch {
    return null;
  }
}
